export enum TabChangeResult {
  InternalChange = 'internalChange',
  NotUnsavedData = 'notUnsavedData',
  KeepEditing = 'keepEditing',
  DiscardChanges = 'discardChanges',
}
